import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledFlexComponent = styled(Ds.Flex)`
    word-break: break-all;
    flex-direction: column;
`;
